export const LV_FILE_EXTENSIONS =
  '.onlv, .x80, .x81, .x82, .x83, .x84, .x85, .x86';
